import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as UserActions from '../../actions/UserActions';
import { bindActionCreators } from 'redux';
import * as GameActions from '../../actions/gameActions'
import * as THREE from 'three';
import Stats from 'stats-js';
import React3 from 'react-three-renderer';
import ReactDOM from 'react-dom';
import TrackballControls from './trackball';
import Ball from './Ball'

class Pitch3D extends Component {

  constructor(props) {
      super(props);

      this.PitchIdent = 50;
      this.ServerPitchWidth = 720;
      this.ServerPitchHeight = 450;
  }

  componentDidMount() {
    this.refs.mainCamera.position.set(this.ServerPitchWidth/2, this.ServerPitchHeight/2,700);

    const controls = new TrackballControls(this.refs.mainCamera/*, ReactDOM.findDOMNode(this.refs.react3)*/);
    controls.rotateSpeed = 2.0;
    controls.zoomSpeed = 1;
    controls.panSpeed = 1;
    controls.staticMoving = true;
    controls.target = new THREE.Vector3( this.ServerPitchWidth/2, this.ServerPitchHeight/2, 0 );
    this.controls = controls;

    this.stats = new Stats();
    this.clock = new THREE.Clock();

    this.stats.domElement.style.position = 'absolute';
    this.stats.domElement.style.top = '700px';

    this.refs.container.appendChild(this.stats.domElement);

    this._drawPitchLines();

    /*var scene = React3.findTHREEObject(this.refs.scene);
    scene.translateX(-this.ServerPitchWidth/2);
    scene.translateY(-this.ServerPitchHeight/2);*/

    //this.refs.scene.position.set(this.ServerPitchWidth/2, this.ServerPitchHeight/2, 0);
  }

  _onAnimate = () => {
    this.stats.update();
    var delta = this.clock.getDelta();
    this.controls.update(delta);
  };

  _drawPitchLines() {
    var lineMaterial = new THREE.LineBasicMaterial({
        color: 0xffffff,
        linewidth: 8
      });

    var width = this.ServerPitchWidth;
    var height = this.ServerPitchHeight;

    var pitch = React3.findTHREEObject(this.refs.pitch);
    pitch.receiveShadow = true;

    pitch.translateX(width/2);
    pitch.translateY(height/2);


    this._drawLine(0, 0, 0, height, lineMaterial);
    this._drawLine(0, height, width, height, lineMaterial);
    this._drawLine(width, height, width, 0, lineMaterial);
    this._drawLine(width, 0, 0, 0, lineMaterial);

    this._drawLine(width/2, 0, width/2, height, lineMaterial);
  }

  _drawLine(x1,y1, x2,y2,material) {
    var geometry = new THREE.Geometry();
    geometry.vertices.push(
      new THREE.Vector3( x1, y1, 0 ),
      new THREE.Vector3( x2, y2, 0 )
    );

    var line = new THREE.Line( geometry, material );
    this.refs.scene.add( line );
  }

  convertToPitchPosition(position, home=true){
    return {
      Top: position.Top,
      Left: position.Left
    }
  }

  render() {
      const divStyle = {
        width: this.props.width + 'px',
        height: this.props.height + 'px'
      };
      console.log('render 3d pitch');
      return (
        <div className="pitch_container">
          <div className="pitch_canvas_container" style={divStyle}  ref="container">
            <React3
              width={this.props.width}
              height={this.props.height}
              antialias
              pixelRatio={window.devicePixelRatio}
              mainCamera="mainCamera"
              ref="react3"
              onAnimate={this._onAnimate}
              shadowMapEnabled={true}
              >
              <resources>
                <texture
                  resourceId="grass"
                  url="/images/grass0.png"
                  wrapS={THREE.RepeatWrapping}
                  wrapT={THREE.RepeatWrapping}
                  repeat={new THREE.Vector2(16,9)}
                  anisotropy={16}
                />
                <meshLambertMaterial
                  resourceId="pitch_material"
                  side={THREE.DoubleSide}
                >
                  <textureResource
                    resourceId="grass"
                  />
                </meshLambertMaterial>
              </resources>
              <scene ref="scene">
                <perspectiveCamera
                  fov={45}
                  aspect={this.props.width / this.props.height}
                  near={1}
                  far={2000}
                  lookAt={this.scenePosition}
                  name="mainCamera"
                  ref="mainCamera"
                />
                <ambientLight
                  color={0x404040}
                />
                <spotLight
                  color={0xffffff}
                  position={new THREE.Vector3(0,0,500)}
                  lookAt={new THREE.Vector3(0,0,0)}
                  castShadow={true}
                  shadowDarkness={1}
                  shadowCameraNear={400}
                  shadowCameraFar={1000}
                  shadowMapWidth={2048}
                  shadowMapHeight={2048}
                />
                <mesh ref="pitch">
                  <planeGeometry
                    width={this.ServerPitchWidth + 2* this.PitchIdent}
                    height={this.ServerPitchHeight + 2* this.PitchIdent}
                    name={"pitch"}
                  />
                  <materialResource
                    resourceId="pitch_material"
                  />
                </mesh>
                <Ball convertToPitchPosition={this.convertToPitchPosition.bind(this)}
                  currentEvent={this.props.currentEvent}
                  gameSpeed={this.props.GameSpeed}
                  pitch3d={true}
                / >
              </scene>
            </React3>
          </div>
        </div>
      )
  }
}

function mapStateToProps(state, ownProps) {
    return {
        HomeTeam: state.HomeTeam,
        AwayTeam: state.AwayTeam,
        Score: state.Score,
        Ball: state.Ball,
        currentEvent: state.currentEvent,
        GameSpeed: state.gameSpeed
    };
}

function mapDispatchToProps(dispatch) {
    return {
        UserActions: bindActionCreators(UserActions, dispatch),
        GameActions: bindActionCreators(GameActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pitch3D)



/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Pitch3D.js
 **/